import { ProductDetailResponseDto } from "definitions/product-storage";
import { DontHaveSubscribeBlock } from "src/widgets";

import { ProductModalContent } from "./ProductModalContent";
import { ProductModalContentSkeleton } from "./ProductModalContentSkeleton";

interface ProductContentWithPaymentProps {
  isLoading?: boolean;
  product?: ProductDetailResponseDto | null;
  hasSubscribe?: boolean;
}

export const ProductContent = ({
  isLoading,
  product,
  hasSubscribe,
}: ProductContentWithPaymentProps) => {
  if (isLoading) {
    return <ProductModalContentSkeleton />;
  }

  if (!product) {
    return <DontHaveSubscribeBlock />;
  }

  return <ProductModalContent product={product} hasSubscribe={hasSubscribe} />;
};
